<cm-routed-dialog [dialogSize]="dialogSizes.Large" [dialogScroll]="false" (close)="overlayClosed()" [needsConfirmationToClose]="$isDirty()">
    <ng-container cm-overlay-content>
        <div class="cm-material-editor-card">
            <div [class.cm-node-editor-split]="$data()?.materialGraph && $screenSize() === screenSizes.splitScreen" class="cm-node-editor">
                @if ($data()?.materialGraph) {
                    <cm-node-editor #nodeEditor [isDirty]="$isDirty()">
                        <ng-container>
                            @if ($data(); as data) {
                                @for (node of nodesService.$nodes(); track node.id) {
                                    <cm-material-node
                                        [material]="node"
                                        [materialId]="data.materialId"
                                        [materialRevisionId]="data.activeRevision?.id"
                                    ></cm-material-node>
                                }
                            }
                        </ng-container>
                    </cm-node-editor>
                } @else if ($data()?.activeRevision) {
                    <div class="cm-no-cycles-revision">This is not a cycles revision</div>
                }
                <div class="cm-top-right-container"></div>
                <div class="cm-top-left-container">
                    <div>
                        <div class="cm-title">
                            <button class="cm-back-icon" (click)="navigateBack()" matTooltip="Back to materials">
                                <i class="far fa-chevron-left"></i>
                            </button>
                            <span class="cm-title-text">{{ $data()?.materialName ?? "Unnamed material" }}</span>
                            @if ($data()?.activeRevision; as activeRevision) {
                                <div class="cm-tag-container">
                                    <span [matMenuTriggerFor]="revisionMenu" class="cm-card-tag"> v{{ activeRevision.number }} ▾ </span>
                                </div>
                            }
                            @if ($allowSave()) {
                                <cm-button (click)="saveNewMaterialRevision()" class="cm-save-button" styling="save" [disabled]="!$isDirty()">
                                    <ng-container cm-left-icon>
                                        <i class="fa-light fa-floppy-disk"></i>
                                    </ng-container>
                                    <ng-container cm-text> Save </ng-container>
                                </cm-button>
                            }
                        </div>
                    </div>
                    @if ($data()?.materialGraph) {
                        <div cdkOverlayOrigin #addNodesTrigger="cdkOverlayOrigin" (click)="$addNodesMenuOpen.set(!$addNodesMenuOpen())">
                            <cm-button class="cm-add-button">
                                <ng-container cm-left-icon>
                                    <i class="far fa-plus"></i>
                                </ng-container>
                                <ng-container cm-text> Add a new node </ng-container>
                            </cm-button>
                        </div>
                        <ng-template
                            cdkConnectedOverlay
                            [cdkConnectedOverlayOrigin]="addNodesTrigger"
                            [cdkConnectedOverlayOpen]="$addNodesMenuOpen()"
                            [cdkConnectedOverlayPositions]="addNodesMenuPosition"
                            cdkConnectedOverlayUsePopover="global"
                            [cdkConnectedOverlayHasBackdrop]="true"
                            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                            (backdropClick)="$addNodesMenuOpen.set(false)"
                        >
                            <div class="cm-add-menu-container">
                                <div class="cm-add-menu-all">
                                    <cm-toggle [toggle]="$showAllNodes()" (toggleChange)="$showAllNodes.set($event)">
                                        <ng-container cm-text>All</ng-container>
                                    </cm-toggle>
                                </div>
                                <div class="cm-add-menu-sections">
                                    @for (section of $addNodeSections(); track section.label) {
                                        <cm-add-menu-section>
                                            <ng-container cm-section-title>
                                                @if (section.icon) {
                                                    <i class="far fa-{{ section.icon }}"></i>
                                                }
                                                {{ section.label }}
                                            </ng-container>
                                            <ng-container cm-section>
                                                @for (
                                                    item of $showAllNodes() ? section.items.concat(section.extraItems ?? []) : section.items;
                                                    track item.prototype.definition.nodeClass
                                                ) {
                                                    <cm-list-item (click)="addNode(item)">
                                                        <ng-container cm-title> {{ item.prototype.definition.ui.label }}</ng-container>
                                                    </cm-list-item>
                                                }
                                            </ng-container>
                                        </cm-add-menu-section>
                                    }
                                </div>
                            </div>
                        </ng-template>
                    }
                </div>
            </div>
            @if ($data()?.materialId && $data()?.nodeEditorTemplateId) {
                @if ($data()?.materialGraph; as materialGraph) {
                    <div
                        [class.cm-splitscreen]="$screenSize() === screenSizes.splitScreen"
                        [class.cm-fullscreen]="$screenSize() === screenSizes.fullScreen"
                        [class.cm-minimize]="$screenSize() === screenSizes.minimize"
                        class="cm-preview-scene-container"
                    >
                        <cm-title-bar (screenSizeChange)="$screenSize.set($event)" class="cm-title-bar"></cm-title-bar>
                        <cm-preview-scene [materialGraph]="materialGraph" class="cm-preview-scene"></cm-preview-scene>
                    </div>
                }
            }
        </div>
    </ng-container>
</cm-routed-dialog>
<mat-menu #revisionMenu="matMenu">
    @for (revision of $data()?.cyclesRevisions ?? []; track revision.id) {
        <button mat-menu-item [disabled]="revision.id === $data()?.activeRevision?.id" (click)="loadRevision(revision.id)">v{{ revision.number }}</button>
    }
</mat-menu>
